export const libsMap: { [key: string]: any } = {
  // echarts: 'https://staticres.linhuiba.com/libs/echarts/5.1.2/echarts-flow.min.js',
  // css
  videoJS: 'https://staticres.linhuiba.com/styles/video-js.font.css', // markdown编辑器css样式
  YDPlayer: 'https://staticres.linhuiba.com/libs/ydplayer/20220728/ydplayer-compatible.js',
  jPlayer: '/player.js',
};
